import React, { useState } from "react";
import { useEffect } from "react";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { Link } from "react-router-dom";
import "../css/App.css";
const scrollToSection = (id) => {
    const section = document.getElementById(id);
    if (section) {
        section.scrollIntoView({ behavior: "smooth" });
    }
};



const Navbar = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [user, setUser] = useState(null);

    useEffect(() => {
        const auth = getAuth();
        const unsubscribe = onAuthStateChanged(auth, u => setUser(u));
        return () => unsubscribe();
    }, []);

    const handleLogout = async () => {
        const auth = getAuth();
        await signOut(auth);
    };

    const toggleMenu = () => setIsMenuOpen(!isMenuOpen);
    useEffect(() => {
        const hamburger = document.getElementById("hamburger");
        const navLinks = document.querySelector(".nav-links");

        if (hamburger && navLinks) {
            const toggle = () => navLinks.classList.toggle("open");
            hamburger.addEventListener("click", toggle);
            return () => hamburger.removeEventListener("click", toggle);
        }
    }, []);

    return (
        <nav className="navbar" >

            <div className="logo-container" onClick={() => scrollToSection("hero")}>
                <a href="/">
                    <img src="/SOLE-logo.svg" alt="SOLE Logo" className="logo" />
                </a>
                <a href="/">
                    <h1 className="title">SOLE</h1>
                </a>
            </div>
            <div className="hamburger" onClick={toggleMenu}>
                <img src="/ham.png" alt="Menu" />
            </div>

            <ul className={`nav-links ${isMenuOpen ? "open" : ""}`}>
                <li className="dropdown">
                    Resources
                    <ul className="dropdown-menu">
                        {/* <li><a href="/talk-resources">Talk Resources</a></li> */}
                        <li><a href="/schools/tamu">TAMU Chapter</a></li>
                        {/* <li><a href="/talks">Talks</a></li> */}
                        <li><a href="https://catholicdefensehub.com/" target="_blank" rel="noopener noreferrer">Catholic Defense Hub</a></li>
                        <li><a href="https://catholic.com" target="_blank" rel="noopener noreferrer">Catholic.com</a></li>
                    </ul>
                </li>
                <li><a href="/candle">Buy a Candle</a></li>
                <li><a href="/give" className="donate-button">Give</a></li>
                <li className="auth-mobile-hide">
                    <div className="auth-buttons" >
                        {user ? (
                            <>
                                <Link to="/national" className="nav-button">National</Link>
                                <button onClick={handleLogout} className="nav-button">Logout</button>
                            </>
                        ) : (
                            <Link to="/login" className="nav-button">Login</Link>
                        )}
                    </div>
                </li>
            </ul>
        </nav>
    );
};

export default Navbar